import * as React from 'react';
import videojs, {VideoJsPlayerOptions} from 'video.js';
import Container from 'containers/Container';
import 'video.js/dist/video-js.css';

export const defaultVideoPlayerOptions = {
  autoplay: false,
  controls: true,
  playbackRates: [0.5, 1, 1.5, 2],
  sources: [{
    src: 'https://vjs.zencdn.net/v/oceans.mp4',
    type: 'video/mp4',
  }],
};

/**
 * the function return default video player options with custom sources
 * @param {any} props
 * @return {any}
 */
function getVideoPlayerProps(props: any) {
  const sources = [{
    src: props.src,
    type: 'video/mp4',
  }];

  return {
    ...defaultVideoPlayerOptions,
    ...props,
    sources,
  };
}


/**
 * Video player class component
 * @return {React.ReactElement}
 */
export default class VideoPlayer extends React.Component<VideoJsPlayerOptions> {
  private player: videojs.Player | undefined;
  private videoNode: HTMLVideoElement | any;
  /**
   * instantiate Video.js
   */
  componentDidMount() {
    console.log(getVideoPlayerProps(this.props));
    this.player = videojs(
        this.videoNode,
        getVideoPlayerProps(this.props),
    );
  }

  /**
   * destroy player on unmount
   */
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  /**
   * Main render
   * @return {React.ReactElement}
   */
  render() {
    return (
      <Container data-vjs-player>
        <video
          ref={ (node) => this.videoNode = node }
          className="video-js vjs-16-9"
        />
      </Container>
    );
  }
}
